import React from 'react'
import { Link } from 'gatsby'
import classNames from 'classnames'
import { Row, Col, Container } from 'reactstrap'
import classes from './assets/free-practice-tests/free-practice-tests.module.scss'
import CheckMarkIcon from './assets/free-practice-tests/checkMarkIcon'
import PageHelmet from '../components/PageHelmet'

const FreePracticeTests = ({ location }) => {
  return (
    <Container>
      <PageHelmet
        title="16 Free Practice Aptitude Tests - Inc Numerical Reasoning, Verbal Reasoning"
        description="Download free psychometric tests for free right now (no details needed). Includes numerical, verbal, abstract, mechanical, spatial."
        url={`https://psychometric-success.com${location.pathname}`}
      />
      <Row className={classes.marginTB5}>
        <Col>
          <h1 className="text-center">Free Practice Aptitude Tests</h1>
        </Col>
      </Row>
      <Row>
        <Col className={classes.numerical}>
          <h3>
            <strong>Numerical</strong> Tests
          </h3>
          <ul>
            <li>
              <CheckMarkIcon />
              <Link to="/content/aptitude-tests/test-types/practice-numerical-reasoning-tests">
                Numerical Reasoning
              </Link>
            </li>
            <li>
              <CheckMarkIcon />
              <Link to="/content/aptitude-tests/test-types/practice-numerical-estimation-tests">
                Numerical Estimation
              </Link>
            </li>
            <li>
              <CheckMarkIcon />
              <Link to="/content/aptitude-tests/test-types/practice-data-interpretation-tests">
                Data Interpretation
              </Link>
            </li>
          </ul>
        </Col>
        <Col className={classes.verbal}>
          <h3>
            <strong>Verbal</strong> Tests
          </h3>
          <ul>
            <li>
              <CheckMarkIcon />
              <Link to="/content/aptitude-tests/test-types/free-verbal-reasoning-practice-tests">
                Verbal Reasoning
              </Link>
            </li>
            <li>
              <CheckMarkIcon />
              <Link to="/content/aptitude-tests/test-types/practice-verbal-ability-comprehension-tests">
                Verbal Comprehension
              </Link>
            </li>
            <li>
              <CheckMarkIcon />
              <Link to="/content/aptitude-tests/test-types/practice-spelling-tests">
                Spelling
              </Link>
            </li>
            <li>
              <CheckMarkIcon />
              <Link to="/content/aptitude-tests/test-types/practice-word-meaning-tests">
                Word Meaning
              </Link>
            </li>
            <li>
              <CheckMarkIcon />
              <Link to="/content/aptitude-tests/test-types/practice-word-relationship-tests">
                Word Relationships
              </Link>
            </li>
          </ul>
        </Col>
      </Row>
      <Row className={classes.marginT2}>
        <Col className={classes.abstract}>
          <h3>
            <strong>Abstract</strong> Reasoning
          </h3>
          <ul>
            <li>
              <CheckMarkIcon />
              <Link to="/content/aptitude-tests/test-types/free-practice-abstract-reasoning-tests">
                Abstract Reasoning
              </Link>
            </li>
            <li>
              <CheckMarkIcon />
              <Link to="/content/aptitude-tests/test-types/practice-diagrammatic-reasoning-tests">
                Diagrammatic Reasoning
              </Link>
            </li>
          </ul>
        </Col>
        <Col className={classes.spatial}>
          <h3>
            <strong>Spatial, Technical & Mechanical</strong> Reasoning
          </h3>
          <ul>
            <li>
              <CheckMarkIcon />
              <Link to="/content/aptitude-tests/test-types/practice-spatial-ability-tests">
                Spatial Ability
              </Link>
            </li>
            <li>
              <CheckMarkIcon />
              <Link to="/content/aptitude-tests/test-types/practice-mechanical-reasoning-tests">
                Mechanical Reasoning
              </Link>
            </li>
          </ul>
        </Col>
        <Col className={classes.clerical}>
          <h3>
            <strong>Clerical</strong> Ability
          </h3>
          <ul>
            <li>
              <CheckMarkIcon />
              <Link to="/content/aptitude-tests/test-types/practice-data-checking-tests">
                Data Checking
              </Link>
            </li>
            <li>
              <CheckMarkIcon />
              <Link to="/content/aptitude-tests/test-types/practice-concentration-tests">
                Concentration & Work Rate
              </Link>
            </li>
          </ul>
        </Col>
      </Row>
      <Row className={classNames(classes.marginTB5, 'justify-content-center')}>
        <a
          className={classes.moreFreeTests}
          href="https://www.wikijob.co.uk/aptitude-tests-home"
          target="_blank"
          rel="noreferrer"
        >
          More free practice aptitude tests
        </a>
      </Row>
    </Container>
  )
}

export default FreePracticeTests
